// # Terms and Privacy Policy Modal Component
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TermsPrivacyModal.css';

function TermsPrivacyModal({ isOpen, onClose, onConfirm }) {
  const [accepted, setAccepted] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="tpm_modal-overlay">
      <div className="tpm_modal-content">
        <h2>Terms & Privacy Policy</h2>
        <div className="tpm_modal-text">
          <p>Before completing your registration, please review and accept our:</p>
          <ul>
            <li><Link to="/terms" target="_blank">Terms of Service</Link></li>
            <li><Link to="/privacy" target="_blank">Privacy Policy</Link></li>
          </ul>
        </div>
        
        <div className="tpm_checkbox-container">
          <label>
            <input 
              type="checkbox" 
              checked={accepted} 
              onChange={(e) => setAccepted(e.target.checked)}
            />
            I have read and agree to the Terms of Service and Privacy Policy
          </label>
        </div>

        <div className="tpm_button-group">
          <button 
            className="tpm_button-cancel" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="tpm_button-confirm" 
            onClick={() => onConfirm(accepted)}
            disabled={!accepted}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsPrivacyModal; 